
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Input, Spinner } from "@nextui-org/react"; // ✅ Replaced @heroui/react with NextUI Spinner
import RevealBlurFX from "../../../components/Effect/RevealBlurFX";
import { BASEURL } from "../../../constant/constant";

export const SearchIcon = (props) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="1em"
    role="presentation"
    viewBox="0 0 24 24"
    width="1em"
    {...props}
  >
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M22 22L20 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

function ProductCategory() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [currentIndexx, setCurrentIndexx] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [visibleSlides, setVisibleSlides] = useState(5);
  const [searchItem, setSearchItem] = useState("");
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);  // Flag persists across re-runs
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const location = useLocation();
  const { categoryId, subCategoryId, productItemId } = location.state || {};

  console.log("Category ID:", categoryId);
  console.log("Sub Category ID:", subCategoryId);
  console.log("Product Item ID:", productItemId);

  // const BASE_URL = "http://192.168.1.6:3000";

  // Separate reusable function
  const fetchCategories = async () => {
    const response = await fetch(`${BASEURL}/api/product/getCategory`, {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();

    if (data.categories) {
      return data.categories.map((item) => ({
        id: item.category.category_id,
        slug: item.category.category_slug,
        title: item.category.category_name,
        src: `${BASEURL}${item.category.img_url}`,
        route: `/category/${item.category.category_id}`,
      }));
    }
    return [];
  };
  // Clean useEffect - NO AbortController
  useEffect(() => {
    if (hasFetched.current) return;  // Blocks second run completely

    fetchCategories()
      .then((mappedCategories) => {
        setCategories(mappedCategories);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      })
      .finally(() => setLoading(false));

    hasFetched.current = true;  // No cleanup return needed
  }, []);

  const Search_Product = async (query) => {
    if (!query.trim()) {
      setFilteredResults([]);
      return;
    }

    try {
      const response = await fetch(
        `${BASEURL}/api/product/serachProduct?term=${query}`
      );

      if (!response.ok) {
        throw new Error("Server is not responding");
      }

      const result = await response.json();
      console.log("Full API Response:", result);

      if (result.data && Array.isArray(result.data)) {
        const extractedProducts = result.data.flatMap((item) => {
          console.log("Item:", item);

          const category = item.category;
          console.log("Category:", category);

          const categoryData = category?.category_data;
          console.log("Category Data:", categoryData);

          const product = categoryData?.products;
          console.log("Product:", product);

          if (!category || !categoryData || !product) return [];

          const productItemId = product?.product_item_id;
          console.log("Product Item ID:", productItemId);

          return {
            ...product,
            slug: item.slug,
            sub_category_slug: categoryData.sub_category_slug,
            product_item_id: productItemId,
          };
        });

        setFilteredResults(extractedProducts);
      } else {
        setFilteredResults([]);
      }
    } catch (error) {
      console.error("API is not responding", error);
      setFilteredResults([]);
    }
  };

  const extendedSlides = [...categories, ...categories.slice(0, visibleSlides)];

  useEffect(() => {
    const updateVisibleSlides = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setVisibleSlides(1);
      } else if (width < 1024) {
        setVisibleSlides(3);
      } else {
        setVisibleSlides(5);
      }
    };

    updateVisibleSlides();
    window.addEventListener("resize", updateVisibleSlides);
    return () => window.removeEventListener("resize", updateVisibleSlides);
  }, []);

  const handleSuggestionClick = (item) => {
    const categoryId = item.category_id || item.category?.category_id;
    const subCategoryId = item.sub_category_id || item.category?.category_data?.sub_category_id;
    const productId = item.product_id;

    if (!categoryId || !subCategoryId || !productId) {
      console.error("Invalid product data:", item);
      return;
    }

    navigate(`/productdetails/${categoryId}/${subCategoryId}/${productId}`);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexx((prevIndex) => {
        if (prevIndex === categories.length) {
          setIsTransitioning(false);
          return 0;
        }
        setIsTransitioning(true);
        return prevIndex + 1;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [categories.length]);

  const handleTransitionEnd = () => {
    if (currentIndexx === categories.length) {
      setIsTransitioning(false);
      setCurrentIndexx(0);
    } else {
      setIsTransitioning(true);
    }
  };
  const getTranslateValue = () => {
    return -(currentIndexx * (100 / visibleSlides));
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (!value.trim()) {
      setFilteredResults([]);
      return;
    }

    // First, filter locally if data is already fetched
    const localResults = categories.filter((item) =>
      item.title.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredResults(localResults);

    // Then fetch from API for better results
    Search_Product(value);
  };

  const handlePrevClick = () => {
    if (currentIndexx === 0) return;
    setIsTransitioning(true);
    setCurrentIndexx((prev) => prev - 1);
  };

  const handleNextClick = () => {
    if (currentIndexx >= categories.length) return;
    setIsTransitioning(true);
    setCurrentIndexx((prev) => prev + 1);
  };

  return (
    <div className="forthdiv flex flex-col p-2">
      <Helmet>
        <title>Our Product Categories | SEA</title>
        <meta name="description" content="Explore our range of products." />
        <meta name="keywords" content="Solar, Controllers, Pumps, Inverters || मागेल त्याला सौर कृषी पंप योजना" />
        <meta property="og:title" content="Explore Our Product Categories" />
        <meta property="og:description" content="Discover a variety of products available at SEA." />
        <meta property="og:url" content="https://seaiot.in/products" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div>
        <div className="background-textpc">Product</div>
      </div>

      <RevealBlurFX>
        <div className="product-our mb-4">
          <div className="w-full max-w-md ml-4">
            <Input
              isClearable
              className="productinput"
              style={{ width: 'fit-content' }}
              placeholder="Search Products"
              value={searchQuery}
              onChange={handleSearchChange}
              onClear={() => {
                setSearchQuery("");
                setFilteredResults([]);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && filteredResults.length > 0) {
                  handleSuggestionClick(filteredResults[0]);
                }
              }}
            />
            {filteredResults.map((item, index) => {
              const slug = item.slug;
              const sub_category_slug = item.sub_category_slug;
              const productItemId = item.product_item_id;

              return (
                <div
                  key={index}
                  className="p-2 cursor-pointer hover:bg-gray-100 flex items-center"
                  onClick={() => {
                    console.log("productItemId====>", productItemId);
                    if (slug !== null && slug !== null) {
                      let isSearchable = true;
                      navigate(
                        `/productdetails/${slug}/${sub_category_slug}`
                      );
                    } else {
                      console.error(
                        "Category, Sub-category, or Product Item ID is missing"
                      );
                    }
                  }}
                >
                  <img
                    src={`${BASEURL}${item.img_url}`}
                    alt={item.product_name}
                    className="w-10 h-10 rounded mr-3"
                  />
                  <span>{item.product_description}</span>
                  <span>{item.manufacturer}</span>
                </div>
              );
            })}
          </div>
        </div>
      </RevealBlurFX>

      {loading ? (
        <div className="flex justify-center items-center h-48">
          <Spinner color="warning" label="Loading..." /> {/* ✅ Fixed Spinner */}
        </div>
      ) : (

        <div className="sliderr mb-10">
          <button className="slider-btn left" onClick={handlePrevClick}>&#10094;</button>

          <div
            className="sliderr-inner"
            style={{
              transform: `translateX(${getTranslateValue()}%)`,
              transition: isTransitioning ? "transform 2.5s ease-in-out" : "none",
              width: `${(extendedSlides.length / visibleSlides) * 100}%`,
            }}
            onTransitionEnd={handleTransitionEnd}
          >
            {extendedSlides.map((slide, index) => (
              <div className="singleph1" key={index} onClick={() => navigate(`/ProductSubCategory/${slide.slug}`)}>
                <img
                  className="mt-20"
                  src={slide.src}
                  alt={slide.title}
                  style={{
                    filter: "drop-shadow(5px 5px 10px rgba(0, 0, 0, 0.5))",
                    borderRadius: "8px",
                    transition: "filter 2.5s ease, transform 2.5s ease",
                    height: "225px",
                  }}
                />
                <h3 className="mt-5">{slide.title}</h3>
              </div>
            ))}
          </div>
          <button className="slider-btn right" onClick={handleNextClick}>&#10095;</button>
        </div>
      )}
    </div>
  );
}

export default ProductCategory;
